<template>
  <div class="mx-auto">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text">Admin PMO Daerah</h1>
            <div>
              Berikut adalah Admin PMO Dinas Daerah yang
              <b>mengunci laporan</b> / memiliki tanggung jawab dalam menanggapi laporan ini, untuk membatalkan kuncian
              laporan bisa dengan klik tombol batalkan kunci oleh admin yang terkait
            </div>

            <div v-if="adminPmo && [38, 39].includes(Number(initValue.k_progres_psp))" class="d-flex mt-4">
              <div class="mr-auto">
                <v-list-item>
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-account-lock</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="blue--text">
                      {{ $getDeepObj(adminPmo, 'akun.nama') || '' }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="black--text">
                      <div>{{ $getDeepObj(adminPmo, 'instansi.nama') || '' }}</div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
              <div>
                <v-btn
                  v-if="$allow('psp-peserta-pendampingan-pa.batal-kunci', $getDeepObj(initValue, 'policies'))"
                  class="mt-3"
                  color="orange"
                  depressed
                  outlined
                  @click="$emit('batalKunci', initValue)"
                >
                  <v-icon left>mdi-lock-open</v-icon>
                  Batalkan Kunci
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-title>Informasi Laporan</v-card-title>
      <v-card-text>
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-label color="caption"><small>Jadwal Laporan</small></v-label>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-calendar-month</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <div class="blue--text">
                      {{ laporanJadwal }}
                    </div>
                    <div class="black--text">
                      <b>Periode Laporan Berlaku</b>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="4">
                <v-label color="caption"><small>Nama Sekolah</small></v-label>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-office-building-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <div class="blue--text">
                      {{ $getDeepObj(laporan, 'sekolah.nama') || '-' }}
                    </div>
                    <div class="black--text">
                      <b>NPSN : </b>
                      {{ $getDeepObj(laporan, 'sekolah.npsn') || '-' }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="4">
                <v-label color="caption"><small>Nama Fasilitator</small></v-label>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <div class="blue--text">
                      {{ $getDeepObj(laporan, 'psp_kp_pa_pendampingan.psp_profil_pa.ptk.nama') || '-' }}
                    </div>
                    <div class="black--text">
                      <b>No. UKG/SIMPKB ID : </b>
                      {{
                        $getDeepObj(laporan, 'psp_kp_pa_pendampingan.psp_profil_pa.ptk.data.no_ukg') ||
                          $getDeepObj(laporan, 'psp_kp_pa_pendampingan.psp_profil_pa.ptk.ptk_id') ||
                          '-'
                      }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-2"></v-divider>
        <v-row no-gutters>
          <v-col cols="12" md="4">
            <v-label color="caption"><small>Waktu Laporan</small></v-label>
            <div class="black--text subtitle-1 font-weight-medium">
              {{ $localDate($getDeepObj(initValue, 'created_at'), false, true) }}
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-label color="caption"><small>Judul Laporan</small></v-label>
            <div class="black--text subtitle-1 font-weight-medium">
              {{ $getDeepObj(initValue, 'm_kp_instrumen_psp.keterangan') || '-' }}
            </div>
          </v-col>
          <v-col cols="12" md="4" v-if="!isPreview && adminPmo && [38, 39].includes(Number(initValue.k_progres_psp))">
            <base-form-generator class="mt-2" :schema="schema['waktu']" v-model="form" />
          </v-col>
          <v-col
            cols="12"
            md="4"
            v-if="isPreview && ($getDeepObj(initValue, 'psp_kp_pa_sekolah_instrumen_pmos') || []).length"
          >
            <v-label color="caption">
              <small> Perkiraan Waktu Selesai {{ [36, 37].includes(+form.k_progres_psp) ? '' : 'Daerah' }} </small>
            </v-label>
            <div class="black--text subtitle-1 font-weight-medium">
              {{
                [36, 37].includes(+form.k_progres_psp)
                  ? $localDate($getDeepObj(initValue, 'tgl_rencana_pusat'))
                  : $localDate($getDeepObj(initValue, 'tgl_rencana_daerah'))
              }}
              <span v-if="getStatus" :class="getStatus === 'lewat' ? 'red--text' : 'orange--text'">
                {{ getStatus === 'lewat' ? '(Melampaui batas waktu)' : '(Masih dalam waktu)' }}
              </span>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-label color="caption"><small>Deskripsi Hambatan</small></v-label>
            <div class="black--text">
              {{ $getDeepObj(initValue, 'deskripsi') || '-' }}
            </div>
          </v-col>
        </v-row>
        <div class="mt-2">
          <template v-if="($getDeepObj(initValue, 'psp_kp_pa_sekolah_instrumen_pmos') || []).length">
            <template v-for="(item, i) in $getDeepObj(initValue, 'psp_kp_pa_sekolah_instrumen_pmos') || []">
              <v-card
                v-if="![38, 39].includes(Number(item.k_progres_psp || 0))"
                flat
                :color="i % 2 === 0 ? '#FFF4E9' : '#E8F2FF'"
                class="my-2 pa-3"
                :key="i"
              >
                <div class="subtitle-1 font-weight-bold">Tanggapan {{ $getDeepObj(item, 'instansi.nama') }}</div>
                <div class="mt-3">
                  <v-chip
                    dark
                    small
                    :color="WARNA_STATUS[item.k_progres_psp] && WARNA_STATUS[item.k_progres_psp]['color']"
                  >
                    <v-icon small left>
                      {{ WARNA_STATUS[item.k_progres_psp] && WARNA_STATUS[item.k_progres_psp]['icon'] }}
                    </v-icon>
                    {{ $getDeepObj(item, 'm_kp_opsi_psp_progres_psp.keterangan') }}
                  </v-chip>
                  <v-alert
                    class="my-2"
                    prominent
                    text
                    border="left"
                    :color="WARNA_STATUS[item.k_progres_psp] && WARNA_STATUS[item.k_progres_psp]['color']"
                  >
                    {{ item.catatan || '-' }}
                  </v-alert>
                  <a v-if="item.url_dokumen" :href="item.url_dokumen" target="_blank">
                    <v-icon small left>
                      mdi-file
                    </v-icon>
                    {{ item.url_judul || item.url_dokumen }}
                  </a>
                </div>
              </v-card>
            </template>
          </template>
          <v-card
            flat
            color="#FFF4E9"
            class="pa-3"
            v-if="isExistArray($getDeepObj(initValue, 'status_instansi'), $getDeepObj(initValue, 'status_update'))"
          >
            <div class="subtitle-1 font-weight-bold">Tanggapan Anda terkait laporan ini?</div>
            <div class="mt-3">
              <template v-for="(item, i) in $getDeepObj(initValue, 'status_update')">
                <v-btn
                  v-if="$getDeepObj(initValue, 'status_instansi').includes(item)"
                  :key="i"
                  :outlined="form['k_progres_psp'] !== item"
                  :color="WARNA_STATUS[item] && WARNA_STATUS[item]['color']"
                  class="mx-md-1"
                  small
                  dark
                  depressed
                  @click="setOpsiPsp(item)"
                >
                  <v-icon left>{{ WARNA_STATUS[item] && WARNA_STATUS[item]['icon'] }}</v-icon>
                  {{ config['progress_pa'][item] && config['progress_pa'][item]['keterangan'] }}
                </v-btn>
              </template>
            </div>
          </v-card>
          <div class="mt-4" v-if="$getDeepObj(initValue, 'status_update').includes(form['k_progres_psp'])">
            <validation-provider name="Deskripsi Hambatan" rules="maxChar: 500" v-slot="{ errors }">
              <v-label class="subtitle-2">
                {{
                  WARNA_STATUS[Number(form['k_progres_psp'])] &&
                    WARNA_STATUS[Number(form['k_progres_psp'])]['catatanTeks']
                }}
              </v-label>
              <v-textarea
                class="mt-2"
                v-model="form['catatan']"
                hint="Maksimal 500 karakter"
                persistent-hint
                dense
                outlined
                :readonly="isPreview"
                :error-messages="errors"
              >
              </v-textarea>
              <base-form-generator class="mt-2" :schema="schema['response']" v-model="form" />
            </validation-provider>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import { ValidationProvider } from 'vee-validate';
import { isExistArray } from '@utils/format';
export default {
  props: {
    initValue: {
      type: Object,
      default: null,
    },
    config: {
      type: Object,
      default: () => {},
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
  },
  components: { BaseFormGenerator, ValidationProvider },
  data() {
    return {
      id: '',
      form: {},
      WARNA_STATUS: {
        32: { color: 'orange', icon: 'mdi-check', catatanTeks: 'Catatan' },
        33: { color: 'primary', icon: 'mdi-check', catatanTeks: 'Saran/Solusi' },
        34: { color: '#FF4A4A', icon: 'mdi-close', catatanTeks: 'Catatan untuk Fasilitator Pelapor' },
        35: { color: '#FF7F2A', icon: 'mdi-send', catatanTeks: 'Catatan untuk PMO Pusat' },
        36: { color: 'success', icon: 'mdi-check', catatanTeks: 'Saran/Solusi' },
        37: { color: '#FF4A4A', icon: 'mdi-close', catatanTeks: 'Catatan untuk PMO Dinas' },
      },
    };
  },
  computed: {
    laporan() {
      return this.$getDeepObj(this.initValue, 'psp_kp_pa_sekolah_laporan') || {};
    },

    laporanJadwal() {
      const kpPa = this.$getDeepObj(this.laporan, 'psp_kp_pa_sekolah.psp_kp_pa') || {};
      const pendampinganKePmo = this.$getDeepObj(this.config, 'pendampingan_ke-pmo') || {};

      return this.$getDeepObj(pendampinganKePmo, `${kpPa.gelombang}.${this.laporan.pendampingan_ke}`);
    },

    schema() {
      return {
        waktu: [
          {
            type: 'VDatePicker',
            name: [36, 37, 39].includes(this.form.k_progres_psp) ? 'tgl_rencana_pusat' : 'tgl_rencana_daerah',
            label: 'Perkiraan Waktu Selesai',
            labelColor: 'grey',
            usePrependInnerIcon: 'mdi-calendar-month',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            hideDetails: true,
            dense: true,
            grid: { cols: 12, md: 10 },
          },
        ],
        response: [
          {
            type: 'VTextField',
            name: 'url_dokumen',
            label: 'Link Dokumen atau Berkas (Isikan jika perlu)',
            labelColor: 'secondary',
            subHint: 'Pastikan Anda memasukkan link <b>valid</b> yang dapat diakses',
            required: false,
            grid: { cols: 12, md: 6, sm: 12 },
            outlined: true,
            dense: true,
            singleLine: true,
            prependInnerIcon: 'mdi-file',
          },
          {
            type: 'VTextField',
            name: 'url_judul',
            label: 'Judul Link yang Anda isikan',
            labelColor: 'secondary',
            hint: '',
            required: false,
            grid: { cols: 12, md: 6, sm: 12 },
            outlined: true,
            singleLine: true,
            dense: true,
          },
        ],
      };
    },

    adminPmo() {
      const instruments = this.$getDeepObj(this, 'initValue.psp_kp_pa_sekolah_instrumen_pmos') || [];
      const k_proses = this.$getDeepObj(this, 'initValue.k_progres_psp') || 0;
      return instruments.find((s) => Number(s.k_progres_psp) === Number(k_proses)) || false;
    },

    getStatus() {
      const kProgresPsp = this.$getDeepObj(this.initValue, 'k_progres_psp') || '';
      const tglRencanaPusat = this.$getDeepObj(this.initValue, 'tgl_rencana_pusat') || '';
      const tglRencanaDaerah = this.$getDeepObj(this.initValue, 'tgl_rencana_daerah') || '';

      if (!tglRencanaPusat && !tglRencanaDaerah) {
        return '';
      }

      if ([36, 37].includes(kProgresPsp)) {
        return this.$compareDate(new Date(), false, `${tglRencanaPusat} 23:59`) ? 'belum' : 'lewat';
      }

      return this.$compareDate(new Date(), false, `${tglRencanaDaerah} 23:59`) ? 'belum' : 'lewat';
    },
  },
  methods: {
    reset() {
      this.id = '';
      this.form = {
        catatan: '',
        k_progres_psp: '',
        url_judul: '',
        url_dokumen: '',
      };
    },

    isExistArray(source, target) {
      return isExistArray(source, target);
    },

    initForm(value) {
      if (!value) return;
      this.id = value && value['psp_kp_pa_sekolah_instrumen_id'];
      // set form
      this.$set(this.form, 'k_progres_psp', (value && value['k_progres_psp']) || '');
      this.$set(this.form, 'catatan', (value && value['catatan']) || '');
      this.$set(this.form, 'url_dokumen', (value && value['url_dokumen']) || '');
      this.$set(this.form, 'url_judul', (value && value['url_judul']) || '');
      this.$set(this.form, 'tgl_rencana_daerah', (value && value['tgl_rencana_daerah']) || '');
      this.$set(this.form, 'tgl_rencana_pusat', (value && value['tgl_rencana_pusat']) || '');
    },

    setOpsiPsp(value) {
      if (this.isPreview) return;
      this.$set(this.form, 'k_progres_psp', value);
    },

    getValue() {
      return {
        id: this.id,
        form: this.form,
      };
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
